export default __webpack_public_path__ + "static/media/twitter-logo.d89d9a86.svg";